import React from 'react';
import { Card, CardContent, Typography, List, ListItem, ListItemText, Divider, Button } from '@mui/material';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { useTranslation } from 'react-i18next';
import SimpleDialog from 'qubCommon/Dialogs/SimpleDialog';
import { processPayment } from 'apis/controllers/membership';

const TotalAmountCard = ({ totalAmountData, paymentButton = null }) => {
    const { t } = useTranslation();

    return (
        <Card
            elevation={3}
            sx={{
                borderRadius: 3,
                border: '3px solid #4CAF50', // Green border to indicate total due
                backgroundColor: '#F1F8E9', // Light green background
                display: 'flex',
                flexDirection: 'column',
                minWidth: 250
            }}
        >
            <CardContent>
                {/* Title */}
                <Typography variant="h4" fontWeight="bold" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                    <AttachMoneyIcon sx={{ fontSize: 30, color: 'primary.main', mr: 1 }} />
                    {t('Total to Pay')}
                </Typography>

                <Divider sx={{ mb: 2 }} />
                {!(totalAmountData?.amounts?.length > 0) ? (
                    <Typography align="center" variant="h4">
                        No pending payments!
                    </Typography>
                ) : (
                    <List dense>
                        {totalAmountData.amounts.map((item, index) => {
                            item;
                            return (
                                <ListItem key={index} sx={{ py: 0.5 }}>
                                    <ListItemText primary={`${t(item.label)}:`} />
                                    <Typography fontWeight="bold">${item.amount.toFixed(2)} CAD</Typography>
                                </ListItem>
                            );
                        })}
                    </List>
                )}

                <Divider sx={{ my: 1 }} />
                {/* Total Amount */}
                {totalAmountData?.amounts?.length > 0 ? (
                    <Typography variant="h5" fontWeight="bold" align="right">
                        {t('Total')}: <span style={{ color: '#2E7D32' }}>${totalAmountData.totalAmount.toFixed(2)} CAD</span>
                    </Typography>
                ) : null}
                {totalAmountData?.amounts?.length > 0 ? paymentButton : null}
            </CardContent>
        </Card>
    );
};

export default TotalAmountCard;
